module.exports = __webpack_public_path__ + "static/media/search-close.f6ae3558.svg";